import BaseHttpService from "./https.service";
import pick from "lodash/pick";

function cleanExperimentParameters(data) {
  if (!Array.isArray(data.keys) || !Array.isArray(data.variants)) return data;
  return {
    ...data,
    variants: data.variants.map(variant => ({
      ...pick(variant, ['_variant_name', ...data.keys]),
      isl_keys: pick(variant.isl_keys, data.isls || [])
    }))
  };
}

const isLocal = window.location.href.indexOf('localhost') >= 0;
const managerBaseUrl = isLocal ? 'http://localhost:5001/manager' : '/manager';


class ManagerHttpService extends BaseHttpService {
  constructor() {
    super(managerBaseUrl); 
  }

  async fetchApps(params = {}){
    return await this.get("/automation/get", params)
  }
  async fetchAppsDetails(params = {}){
    return await this.get("/automation/get-details", params)
  }
  
  async getItems(type,params){
    const temp = await this.get(`/${type}/all`,params)
    console.log(type,temp)
    return temp;
  }

  async getItem(type,params){
    return await this.get(`/${type}/get`,params)
  }

  async getAllExperiments(params){
    return await this.get("/experiment/all-apps",params)
  }

  async getLookerConfiguration(params = {}){
    return await this.get("/experiment/looker-configuration", params)
  }

  async setTemplateLooks(payload, params = {}){
    return await this.post("/experiment/looker-configuration/templates", payload, params)
  }

  async configAdd(type,payload,params = {}){
    if (type === 'experiment') payload = cleanExperimentParameters(payload);
    const res = await this.post(`/${type}/add`,payload,params)
    return res;
  }
  async configEdit(type, payload, params){
    if (type === 'experiment') payload = { ...payload, data: cleanExperimentParameters(payload.data) };
    const res = await this.post(`/${type}/edit`, payload,params)
    return res;
  }

  async configDelete(type,payload,params){
    const res = await this.post(`/${type}/delete`,{id: payload},params)
    return res;
  }

  async activationOp(payload){
    const res = await this.post(`/${payload.type}/activation`,payload.operation)
    return res;
  }

  async getUserAuthInfo(){
    return await this.get("/auth/user-info")
  }

  async getFirebaseToken(){
    return await this.get("/auth/firebase-token")
  }

  async getParameterHistory(params){
    return await this.get(`/parameter/history/${params.parameterId}`, { aid: params.aid })
  }

  async removeUserFromExperiment(userId, experimentId){
    return await this.post('/user/remove-experiment', { userId, experimentId })
  }

  async translateMessage(baseTranslations, targetLanguages){
    return await this.post('/localization/translate', { baseTranslations, targetLanguages })
  }

  async shortenMessage(items){
    return await this.post('/localization/shorten', { items })
  }

}



export const managerService = new ManagerHttpService();